module.exports = __webpack_public_path__ + "img/vip-banner-bg.82f9dc0d.png";